import React from 'react'
import './Footer.scss';

 const Footer = () => {
    return (
        <div className="footer-component">
            <div className="footer-component__container">
                <span>
                    © 2021 all rights reserved to COTI
                </span>

                <div> 
                    <a href="https://coti.io/privacy" target="_blank" rel="noopener noreferrer">Terms of use</a>
                    <a href="https://coti.io/terms" target="_blank" rel="noopener noreferrer">Privacy statement</a>
                </div>
            </div>
        </div>
    )
}

export default Footer;